<template>
  <div>
    <div class="kt-login__body">
      <div class="kt-login__form">
        <b-form
          class="kt-form form elevation-1"
          @submit.stop.prevent="onSubmit"
        >
          <div class="div heading">
            <h2 class="form-heading">PAYNOWPRO</h2>
            <p>
              {{ isChanging ? "Change Authenticator" : "Setup Authenticator" }}
            </p>
          </div>

          <div
            role="alert"
            v-bind:class="{ show: pageError }"
            class="alert fade alert-danger"
          >
            <div class="alert-text">{{ pageError }}</div>
          </div>

          <template v-if="step === 1">
            <p class="text-muted text-center mb-3">
              {{
                isChanging
                  ? "Scan this QR code with your new authenticator app. Your old device will be replaced once verified."
                  : "Scan this QR code with your authenticator app (e.g. Google Authenticator, Authy)."
              }}
            </p>
            <div v-if="qrCodeDataUrl" class="text-center mb-3">
              <img :src="qrCodeDataUrl" alt="MFA QR Code" />
            </div>
            <div class="form-group text-center">
              <small class="text-muted">
                Or enter the secret manually: <strong>{{ secret }}</strong>
              </small>
            </div>
            <div class="kt-login__actions login-actions">
              <b-button variant="primary" @click="step = 2">Next</b-button>
            </div>
          </template>

          <template v-if="step === 2">
            <p class="text-muted text-center mb-3">
              Enter the 6-digit code from your authenticator app to verify
              setup.
            </p>
            <b-form-group class="form-group" label-for="setup-mfa-token">
              <label class="d1-block">Verification Code</label>
              <b-form-input
                id="setup-mfa-token"
                v-model="$v.code.$model"
                placeholder="000000"
                maxlength="6"
                :state="validateState()"
                aria-describedby="setup-mfa-feedback"
                autocomplete="one-time-code"
              ></b-form-input>
              <b-form-invalid-feedback id="setup-mfa-feedback">
                Please enter a valid 6-digit code.
              </b-form-invalid-feedback>
            </b-form-group>
            <div class="kt-login__actions login-actions">
              <b-button variant="secondary" @click="step = 1">Back</b-button>
              <b-button type="submit" variant="primary"
                >Verify & Enable</b-button
              >
            </div>
          </template>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
import "./auth.css";
import { SETUP_MFA, VERIFY_MFA_SETUP, DISABLE_MFA } from "@/store/auth.module";
import { validationMixin } from "vuelidate";
import {
  required,
  minLength,
  maxLength,
  numeric
} from "vuelidate/lib/validators";
import QRCode from "qrcode";

export default {
  mixins: [validationMixin],
  name: "setup-mfa",
  data() {
    return {
      step: 1,
      secret: null,
      qrCodeDataUrl: null,
      code: null,
      pageError: ""
    };
  },
  validations: {
    code: {
      required,
      numeric,
      minLength: minLength(6),
      maxLength: maxLength(6)
    }
  },
  computed: {
    isChanging() {
      return !!this.$route.query.change;
    }
  },
  async mounted() {
    await this.loadSecret();
  },
  methods: {
    validateState() {
      const { $dirty, $error } = this.$v.code;
      return $dirty ? !$error : null;
    },
    async loadSecret() {
      try {
        this.secret = await this.$store.dispatch(SETUP_MFA);
        const email = this.$store.getters.userEmail;
        const otpAuthUrl = `otpauth://totp/PayNowPro:${email}?secret=${this.secret}&issuer=PayNowPro`;
        this.qrCodeDataUrl = await QRCode.toDataURL(otpAuthUrl);
      } catch (e) {
        this.$logger.error(e);
        this.pageError = "Failed to load MFA setup. Please try again.";
      }
    },
    async onSubmit() {
      this.$v.$touch();
      if (this.$v.$anyError) return;

      try {
        if (this.isChanging) {
          await this.$store.dispatch(DISABLE_MFA);
        }
        await this.$store.dispatch(VERIFY_MFA_SETUP, this.code);
        this.$router.push({ name: "mfa-devices" });
      } catch (e) {
        this.$logger.error(e);
        this.pageError = "Invalid code. Please try again.";
      }
    }
  }
};
</script>
